module.exports = __webpack_public_path__ + "img/logoImg.dc1cb4e9.png";